import vMessage from '@/components/Message/index.js'
import { directiveInstall } from "@/directives/index.js"
import { NODE_ENV } from "@/utils/common";
import publicMethod from '@/utils/publicMethod.js'
import requestMethods from "@/utils/request"
import publicComponents from '@/components/publicComponents.js'
import ThemeInfo from '@/style/theme/themeInfo'
import Bus from '@/utils/bus'
import mapTheme from '@/data/mapTheme'
import i18n from '@/utils/i18n'
//此时我们还没有微应用，所以app为空
let props = {
  requestMethods: requestMethods,//将封装的axios的方法传递给子系统
  plugin: {
    directiveInstall,//公用指令注册插件
    vMessage,//将这个插件传给子应用
  },
  Bus,
  i18n: i18n,
  mapTheme,
  ThemeInfo: ThemeInfo,
  components: publicComponents,
  utils: publicMethod, //传递公用方法
}
let link = location.protocol + "//" + location.hostname
let origin = location.origin
let activeRuleLink = location.pathname
let isDev = NODE_ENV == 'development'
export const apps = [
  {
    name: "platform",
    entry: isDev ? (link + ":185") : (origin + "/microApps/platformSys/"),
    container: "#frame",
    activeRule: activeRuleLink + "#/platform/",
    props: props
  },
  {
    name: "customized",
    entry: isDev ? (link + ":183") : (origin + "/microApps/customizedSys/"),
    container: "#frame",
    activeRule: activeRuleLink + "#/customized/",
    props: props
  },
  {
    name: "analysis",
    entry: isDev ? (link + ":184") : (origin + "/microApps/analysisSys/"),
    container: "#frame",
    activeRule: activeRuleLink + "#/analysis/",
    props: props
  },
  {
    name: "maintenance",
    entry: isDev ? (link + ":181") : (origin + "/microApps/maintenanceSys/"),
    container: "#frame",
    activeRule: activeRuleLink + "#/maintenance/",
    props: props
  }
]
export const comp = {
  name: "publicComponents",
  entry: isDev ? (link + ":186") : (origin + "/microApps/publicSys/"),
  container: "#publicComponents",
  props: {
    ...{ window: window }, ...props
  }
}